<button mat-icon-button [matMenuTriggerFor]="bookingItemDropdown" aria-label="Edit booking item state" i18n-aria-label>
  <mat-icon>more_horiz</mat-icon>
</button>
<mat-menu #bookingItemDropdown="matMenu">
  <button mat-menu-item *ngIf="isPublishable()" (click)="onPublish()" i18n>Publish</button>
  <button mat-menu-item *ngIf="isArchivable()" (click)="onArchive()" i18n>Archive</button>
  <button mat-menu-item *ngIf="isRetractable()" (click)="onRetract()" i18n>Move to draft</button>
</mat-menu>
